<script lang="ts">
    export let color = '#4D4D4D';
</script>

<svg width="10" height="17" viewBox="0 0 10 17" fill="none" stroke={color} role="presentation">
    <path
        d="M0.5 15.7067V0.959931C0.5 0.726534 0.704734 0.5 1.00247 0.5H8.99753C9.29571 0.5 9.5 0.726322 9.5 0.959931V15.7061C9.5 15.9401 9.29527 16.1667 8.99687 16.1667H1.00313C0.704292 16.1667 0.5 15.9403 0.5 15.7067Z"
        stroke-miterlimit="10"
    />
    <path
        d="M5.94514 14.2479C6.01887 13.7936 5.71036 13.3656 5.25607 13.2918C4.80178 13.2181 4.37373 13.5266 4.3 13.9809C4.22627 14.4352 4.53478 14.8632 4.98907 14.937C5.44337 15.0107 5.87141 14.7022 5.94514 14.2479Z"
    />
</svg>
